<template>
  <div class="container-fluid" style="min-height: 100vh">
    <b-alert
      class="position-fixed fixed-top m-0 rounded-0 text-center"
      fade
      :show="dismissCountDown"
      :variant="errorMessage.color"
      @dismissed="dismissed"
    >
      {{ errorMessage.text }}
    </b-alert>

    <!-- Agencia Modal -->
    <b-modal v-model="agenciaDialog" centered :hide-header="true">
      <div class="text-center">
        Solicitamos realizar seu cadastro com e-mail corporativo para que o
        mesmo seja validado como agência.
      </div>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            size="sm"
            class="float-right w-25 ml-3"
            @click="agenciaDialog = false"
            >Ok</b-button
          >
        </div>
      </template>
    </b-modal>

    <img
      class="position-fixed fixed-top m-0 rounded-0 text-center"
      style="top: 20px; left: 30px"
      src="@/assets/logo.png"
      fluid
      alt="Parceiro CAIXA"
      width="65"
      height="65"
    />

    <div class="row">
      <div
        class="col-md-4 d-none d-lg-block vh-100 asd"
        style="
          border-left: 7px solid #f7941e;
          background-color: #058ce1;
          border-top-right-radius: 50%;
        "
      >
        <div
          class="d-flex justify-content-center align-items-center h-100"
        ></div>
      </div>
      <div class="col-md-8 rightCol">
        <div class="d-flex justify-content-center h-100">
          <div class="col-md-7">
            <div class="position-relative">
              <div class="social-box">
                <div class="mb-2">
                  <div v-if="step === 1" :class="{ fadeup: intiateFadeUp }">
                    <h2 class="text-own">Bem Vindo! : )</h2>
                    <span class="lead"> Qual o seu perfil de atuação?</span>
                  </div>
                  <div v-if="step === 2" :class="{ fadeup: intiateFadeUp }">
                    <h2 class="text-own">Sobre a Área de Atuação</h2>
                    <!--<span class="lead">
                      Conte-nos um pouco mais sobre o modelo de atuação.</span
                    >-->
                  </div>
                  <div v-if="step === 3" :class="{ fadeup: intiateFadeUp }">
                    <h2 class="text-own">Cadastro</h2>
                    <span class="lead">
                      Preecha o cadastro para solicitação de acesso.</span
                    >
                  </div>
                </div>
                <div
                  v-if="step === 1"
                  class="row"
                  :class="{ fadeup: intiateFadeUp }"
                >
                  <div class="col-lg-4 col-xs-12 text-center">
                    <div
                      class="
                        box
                        d-flex
                        justify-content-center
                        align-items-center
                      "
                      @click="selectProfile('Corretor Autônomo')"
                    >
                      <div class="">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="32"
                          fill="currentColor"
                          class="bi bi-person-circle mb-2"
                          viewBox="0 0 16 16"
                        >
                          <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                          <path
                            fill-rule="evenodd"
                            d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
                          />
                        </svg>
                        <div class="box-title">
                          <h4 class="mb-0">Corretor Autônomo</h4>
                        </div>
                      </div>
                      <!--<div class="box-text">
                        <span
                          >Lorem ipsum dolor sit amet, id quo eruditi
                          eloquentiam. Assum decore te sed. Elitr scripta
                          ocurreret qui ad.</span
                        >
                      </div>
                      <div class="box-btn">
                        <a href="#">Learn More</a>
                      </div>-->
                    </div>
                  </div>

                  <div class="col-lg-4 col-xs-12 text-center">
                    <div
                      class="
                        box
                        d-flex
                        justify-content-center
                        align-items-center
                      "
                      @click="selectProfile('Imobiliária')"
                    >
                      <div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="32"
                          fill="currentColor"
                          class="bi bi-house mb-2"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M2 13.5V7h1v6.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V7h1v6.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5zm11-11V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"
                          />
                          <path
                            fill-rule="evenodd"
                            d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"
                          />
                        </svg>
                        <div class="box-title">
                          <h4 class="mb-0">Imobiliária</h4>
                        </div>
                      </div>
                      <!--<div class="box-text">
                        <span
                          >Lorem ipsum dolor sit amet, id quo eruditi
                          eloquentiam. Assum decore te sed. Elitr scripta
                          ocurreret qui ad.</span
                        >
                      </div>
                      <div class="box-btn">
                        <a href="#">Learn More</a>
                      </div>-->
                    </div>
                  </div>

                  <div class="col-lg-4 col-xs-12 text-center">
                    <div
                      class="
                        box
                        d-flex
                        justify-content-center
                        align-items-center
                      "
                      @click="selectProfile('Construtor')"
                    >
                      <div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="32"
                          fill="currentColor"
                          class="bi bi-building mb-2"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M14.763.075A.5.5 0 0 1 15 .5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V14h-1v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V10a.5.5 0 0 1 .342-.474L6 7.64V4.5a.5.5 0 0 1 .276-.447l8-4a.5.5 0 0 1 .487.022zM6 8.694 1 10.36V15h5V8.694zM7 15h2v-1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V15h2V1.309l-7 3.5V15z"
                          />
                          <path
                            d="M2 11h1v1H2v-1zm2 0h1v1H4v-1zm-2 2h1v1H2v-1zm2 0h1v1H4v-1zm4-4h1v1H8V9zm2 0h1v1h-1V9zm-2 2h1v1H8v-1zm2 0h1v1h-1v-1zm2-2h1v1h-1V9zm0 2h1v1h-1v-1zM8 7h1v1H8V7zm2 0h1v1h-1V7zm2 0h1v1h-1V7zM8 5h1v1H8V5zm2 0h1v1h-1V5zm2 0h1v1h-1V5zm0-2h1v1h-1V3z"
                          />
                        </svg>
                        <div class="box-title">
                          <h4 class="mb-0">Construtor</h4>
                        </div>
                      </div>
                      <!--<div class="box-text">
                        <span
                          >Lorem ipsum dolor sit amet, id quo eruditi
                          eloquentiam. Assum decore te sed. Elitr scripta
                          ocurreret qui ad.</span
                        >
                      </div>
                      <div class="box-btn">
                        <a href="#">Learn More</a>
                      </div>-->
                    </div>
                  </div>

                  <div class="col-lg-4 col-xs-12 text-center">
                    <div
                      class="
                        box
                        d-flex
                        justify-content-center
                        align-items-center
                      "
                      @click="selectProfile('Advogado Imobiliário')"
                    >
                      <div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="32"
                          fill="currentColor"
                          class="bi bi-briefcase mb-2"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v8A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1h-3zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5zm1.886 6.914L15 7.151V12.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V7.15l6.614 1.764a1.5 1.5 0 0 0 .772 0zM1.5 4h13a.5.5 0 0 1 .5.5v1.616L8.129 7.948a.5.5 0 0 1-.258 0L1 6.116V4.5a.5.5 0 0 1 .5-.5z"
                          />
                        </svg>
                        <div class="box-title">
                          <h4 class="mb-0">Advogado Imobiliário</h4>
                        </div>
                      </div>
                      <!--<div class="box-text">
                        <span
                          >Lorem ipsum dolor sit amet, id quo eruditi
                          eloquentiam. Assum decore te sed. Elitr scripta
                          ocurreret qui ad.</span
                        >
                      </div>
                      <div class="box-btn">
                        <a href="#">Learn More</a>
                      </div>-->
                    </div>
                  </div>

                  <div class="col-lg-4 col-xs-12 text-center">
                    <div
                      class="
                        box
                        d-flex
                        justify-content-center
                        align-items-center
                      "
                      @click="selectProfile('Despachante')"
                    >
                      <div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="32"
                          fill="currentColor"
                          class="bi bi-person mb-2"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"
                          />
                        </svg>
                        <div class="box-title">
                          <h4 class="mb-0">Despachante/ Consultoria</h4>
                        </div>
                      </div>
                      <!--<div class="box-text">
                        <span
                          >Lorem ipsum dolor sit amet, id quo eruditi
                          eloquentiam. Assum decore te sed. Elitr scripta
                          ocurreret qui ad.</span
                        >
                      </div>
                      <div class="box-btn">
                        <a href="#">Learn More</a>
                      </div>-->
                    </div>
                  </div>

                  <div class="col-lg-4 col-xs-12 text-center">
                    <div
                      class="
                        box
                        d-flex
                        justify-content-center
                        align-items-center
                      "
                      @click="selectProfile('Agência')"
                    >
                      <div>
                        <img
                          src="@/assets/img/logo-caixa-41262.png"
                          width="32"
                          class="mb-2"
                        />
                        <div class="box-title">
                          <h4 class="mb-0">Agência</h4>
                        </div>
                      </div>
                      <!--<div class="box-text">
                        <span
                          >Lorem ipsum dolor sit amet, id quo eruditi
                          eloquentiam. Assum decore te sed. Elitr scripta
                          ocurreret qui ad.</span
                        >
                      </div>
                      <div class="box-btn">
                        <a href="#">Learn More</a>
                      </div>-->
                    </div>
                  </div>
                </div>
                <div v-if="step === 2" :class="{ fadeup: intiateFadeUp }">
                  <form
                    class="js-validate"
                    @submit.prevent="handleLead(user)"
                  >
                    <!-- v-show="!userMessageSuccessfullyRegistered" -->
                    <!-- Login -->
                    <div id="login">
                      <!-- Title -->
                      <div class="text-center mb-7" v-if="showInputModal">
                        <h3 class="mb-0">Solicitação de acesso</h3>
                        <p>Você está no caminho certo.</p>
                      </div>
                      <div class="mb-7" v-else>
                        <!--<h3 class="mb-0">Compartilhe conosco</h3>-->
                        <p>
                          Conte-nos um pouco mais sobre o modelo de atuação
                          atual.
                        </p>
                      </div>
                      <!-- End Title -->
                      <!-- Alert Error -->
                      <b-alert
                        :show="dismissCountDown"
                        dismissible
                        fade
                        :variant="errorMessage.color"
                        @dismissed="dismissed"
                      >
                        {{ errorMessage.text }}
                      </b-alert>
                      <!-- End Alert Error -->
                      <!-- Input Group -->
                      <div class="col-sm mb-2 p-0">
                        <div class="input-group input-group-merge">
                          <div class="input-group-prepend">
                            <div class="input-group-text mb-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-geo-alt"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 0 1 8 14.58a31.481 31.481 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z"
                                />
                                <path
                                  d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                                />
                              </svg>
                            </div>
                          </div>

                          <input
                            type="text"
                            class="form-control form-control-sm"
                            name="Em qual região você atua?"
                            v-model="user.actingRegion"
                            placeholder="Em qual região você atua?"
                            aria-label="Em qual região você atua?"
                            :class="{
                              'is-invalid':
                                submitted && $v.user.actingRegion.$error,
                            }"
                            @blur="movetoStepThree"
                          />
                          <div
                            v-if="submitted && !$v.user.actingRegion.required"
                            class="invalid-feedback text-left"
                          >
                            Campo obrigatório
                          </div>
                        </div>
                      </div>
                      <!-- End Input Group -->
                      <!-- Input Group -->
                      <div class="col-sm mb-2 p-0">
                        <label class="input-label sr-only"
                          >Qual a sua média de financiamento mensal?</label
                        >
                        <div class="mb-2">
                          <select
                            class="custom-select custom-select-sm text-muted"
                            :class="{
                              'is-invalid':
                                submitted && $v.user.averageCredit.$error,
                            }"
                            v-model="user.averageCredit"
                            @change="movetoStepThree"
                          >
                            <option value="" disabled>
                              Média de financiamento mensal
                            </option>
                            <option value="Menos de R$ 100 mil">
                              Menos de R$ 100 mil
                            </option>
                            <option value="De R$ 100 mil a R$ 250 mil">
                              De R$ 100 mil a R$ 250 mil
                            </option>
                            <option value="De R$ 250 mil a R$ 500 mil">
                              De R$ 250 mil a R$ 500 mil
                            </option>
                            <option value="De R$ 500 mil a R$ 1 milhão">
                              De R$ 500 mil a R$ 1 milhão
                            </option>
                            <option value="Acima de R$ 1 milhão">
                              Acima de R$ 1 milhão
                            </option>
                          </select>
                          <div
                            v-if="submitted && !$v.user.averageCredit.required"
                            class="invalid-feedback text-left"
                          >
                            Campo obrigatório
                          </div>
                        </div>
                      </div>
                      <!-- End Input Group -->

                      <!-- Input Group -->
                      <div class="col-sm mb-2 p-0">
                        <label class="input-label sr-only"
                          >Como que você realiza os financiamentos dos seus
                          clientes?</label
                        >
                        <div class="input-group mb-2">
                          <select
                            class="form-control custom-select-sm text-muted"
                            :class="{
                              'is-invalid':
                                submitted && $v.user.wayOfPerformance.$error,
                            }"
                            v-model="user.wayOfPerformance"
                            @change="movetoStepThree"
                          >
                            <option value="" disabled>
                              Quem cuida do financiamento
                            </option>
                            <option value="O cliente que cuida dessa parte">
                              O cliente que cuida dessa parte
                            </option>
                            <option value="Meu gerente comercial que cuida">
                              Meu gerente comercial que cuida
                            </option>
                            <option value="Trabalho com um gerente CAIXA">
                              Trabalho com um gerente CAIXA
                            </option>
                            <option value="Trabalho com um correspondente">
                              Trabalho com um correspondente
                            </option>
                          </select>
                          <div
                            v-if="
                              submitted && !$v.user.wayOfPerformance.required
                            "
                            class="invalid-feedback text-left"
                          >
                            Campo obrigatório
                          </div>
                        </div>
                      </div>
                      <!-- End Input Group -->

                      <!-- Input Group -->
                      <div class="col-sm mb-2 p-0">
                        <label class="input-label sr-only"
                          >Há quanto tempo está no mercado?</label
                        >
                        <div class="input-group mb-2">
                          <select
                            class="custom-select custom-select-sm text-muted"
                            :class="{
                              'is-invalid':
                                submitted && $v.user.timeToMarket.$error,
                            }"
                            v-model="user.timeToMarket"
                            @change="movetoStepThree"
                          >
                            <option value="" disabled>
                              Experiência de mercado
                            </option>
                            <option value="Há menos de 1 ano">
                              Há menos de 1 ano
                            </option>
                            <option value="Entre 1 a 2 anos">
                              Entre 1 a 2 anos
                            </option>
                            <option value="Mais de 3 anos">
                              Mais de 3 anos
                            </option>
                          </select>
                          <div
                            v-if="submitted && !$v.user.timeToMarket.required"
                            class="invalid-feedback text-left"
                          >
                            Campo obrigatório
                          </div>
                        </div>
                      </div>
                      <!-- End Input Group -->

                      <!-- Input Group -->
                      <div class="mb-4 d-none">
                        <label class="input-label sr-only">Captura</label>
                        <div
                          class="
                            custom-control custom-checkbox
                            d-flex
                            align-items-center
                            text-muted
                          "
                        >
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            v-model="user.captured"
                            id="captured"
                            name="captured"
                          />
                          <label class="custom-control-label" for="captured">
                            <small> Captura </small>
                          </label>
                        </div>
                      </div>
                      <!--<div class="mb-3">
              <button
                type="submit"
                id="btnConversionTag"
                class="btn btn-block btn-primary btn-wide transition-3d-hover"
                v-if="!loadingBtn"
              >
                Enviar solicitação
              </button>

              <button
                class="btn btn-block btn-primary btn-wide transition-3d-hover"
                type="button"
                v-else
                disabled
              >
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                Enviando...
              </button>
            </div>-->

                      <div class="text-center mt-5">
                        <span class="divider divider-text f-14"
                          >Após preenchimento o mesmo avança automaticamente
                          para a última etapa</span
                        >
                      </div>

                      <!--<a
                  class="btn btn-sm btn-ghost-secondary btn-block mb-2"
                  href="#"
                >
                  <span
                    class="d-flex justify-content-center align-items-center"
                  >
                    <img
                      class="mr-2"
                      src="../../assets/img/160x160/img17.png"
                      alt="Image Description"
                      width="14"
                      height="14"
                    />
                    Sign In with Google
                  </span>
                </a>-->
                    </div>
                  </form>
                </div>
                <div v-if="step === 3">
                  <form
                    class="mt-3 form-signin"
                    @submit.prevent="handleSubmit(user)"
                  >
                    <!-- <div class="mb-3">
                      <h1 class="text-own">Bem Vindo! : )</h1>
                      <span class="lead"> Vamos criar a sua conta.</span>
                    </div> -->
                    <b-row class="justify-content-center">
                      <b-col cols="6">
                        <div class="input-group input-group-merge mb-3">
                          <div class="input-group-prepend">
                            <div class="input-group-text mb-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-person"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"
                                />
                              </svg>
                            </div>
                          </div>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            :class="{
                              'is-invalid':
                                submitted && $v.user.firstName.$error,
                            }"
                            placeholder="Nome"
                            v-model="user.firstName"
                          />
                          <div
                            v-if="submitted && !$v.user.firstName.required"
                            class="invalid-feedback text-left"
                          >
                            Campo obrigatório
                          </div>
                        </div>
                      </b-col>
                      <b-col cols="6">
                        <div class="input-group input-group-merge mb-3">                    
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            :class="{
                              'is-invalid':
                                submitted && $v.user.lastName.$error,
                            }"
                            placeholder="Sobernome"
                            v-model="user.lastName"
                          />
                          <div
                            v-if="submitted && !$v.user.lastName.required"
                            class="invalid-feedback text-left"
                          >
                            Campo obrigatório
                          </div>
                        </div>
                      </b-col>
                      <b-col cols="12" md="6">
                        <div class="input-group input-group-merge mb-3">
                          <div class="input-group-prepend">
                            <div class="input-group-text mb-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-envelope"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"
                                />
                              </svg>
                            </div>
                          </div>
                          <input
                            type="email"
                            class="form-control form-control-sm"
                            :class="{
                              'is-invalid': submitted && $v.user.email.$error,
                            }"
                            placeholder="Seu email"
                            v-model="user.email"
                          />
                          <div
                            v-if="submitted && $v.user.email.$error"
                            class="invalid-feedback text-left"
                          >
                            <span v-if="!$v.user.email.required"
                              >Campo obrigatório.</span
                            >
                            <span v-if="!$v.user.email.email"
                              >Informe um e-mail válido.</span
                            >
                          </div>
                        </div>
                      </b-col>
                      <b-col cols="12" md="6">
                        <div class="input-group input-group-merge mb-3">
                          <div class="input-group-prepend">
                            <div class="input-group-text mb-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="green"
                                class="bi bi-whatsapp"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"
                                />
                              </svg>
                            </div>
                          </div>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            :class="{
                              'is-invalid':
                                submitted && $v.user.phoneNumber.$error,
                            }"
                            placeholder="Whatsapp/Celular"
                            v-model="user.phoneNumber"
                            v-mask="['(##) ####-####', '(##) #####-####']"
                          />
                          <div
                            v-if="submitted && !$v.user.phoneNumber.required"
                            class="invalid-feedback text-left"
                          >
                            Campo obrigatório
                          </div>
                        </div>
                        <!-- <div class="form-group">
                          <label class="sr-only" for="profileType"
                            >Perfil</label
                          >
                          <select
                            class="custom-select custom-select-sm text-muted"
                            :class="{
                              'is-invalid':
                                submitted && $v.user.profileType.$error,
                            }"
                            v-model="user.profileType"
                          >
                            <option value="">Selecione seu Perfil</option>
                            <option value="Advogado Imobiliário">
                              Advogado Imobiliário
                            </option>
                            <option value="Construtor">Construtor</option>
                            <option value="Corretor">Corretor</option>
                            <option value="Despachante">Despachante</option>
                            <option value="Imobiliária">Imobiliária</option>
                          </select>
                          <div
                            v-if="submitted && !$v.user.profileType.required"
                            class="invalid-feedback text-left"
                          >
                            Campo obrigatório
                          </div>
                        </div> -->
                      </b-col>
                      <b-col cols="12" md="6">
                        <div class="input-group input-group-merge mb-3">
                          <div class="input-group-prepend">
                            <div class="input-group-text mb-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-lock"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z"
                                />
                              </svg>
                            </div>
                          </div>
                          <input
                            type="password"
                            class="form-control form-control-sm"
                            :class="{
                              'is-invalid': submitted && $v.user.pass.$error,
                            }"
                            placeholder="Sua senha"
                            v-model="user.pass"
                          />
                          <div
                            v-if="submitted && $v.user.pass.$error"
                            class="invalid-feedback text-left"
                          >
                            <span v-if="!$v.user.pass.required"
                              >Campo obrigatório.</span
                            >
                            <span v-if="!$v.user.pass.minLength"
                              >Informe uma senha com mínimo de 6
                              caracteres.</span
                            >
                          </div>
                        </div>
                      </b-col>
                      <b-col cols="12" md="6">
                        <div class="input-group input-group-merge mb-3">
                          <div class="input-group-prepend">
                            <div class="input-group-text mb-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-lock-fill"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"
                                />
                              </svg>
                            </div>
                          </div>
                          <input
                            type="password"
                            class="form-control form-control-sm"
                            placeholder="Confirme sua senha"
                            v-model="user.pass2"
                            :class="{
                              'is-invalid': submitted && $v.user.pass2.$error,
                            }"
                          />
                          <div
                            v-if="submitted && $v.user.pass2.$error"
                            class="invalid-feedback text-left"
                          >
                            <span v-if="!$v.user.pass2.required"
                              >Campo obrigatório.</span
                            >
                            <span v-if="!$v.user.pass2.sameAsPassword"
                              >Repita a mesma senha informada
                              anteriormente.</span
                            >
                          </div>
                        </div>
                      </b-col>
                      <b-col cols="12">
                        <div
                          class="
                            custom-control custom-checkbox
                            d-flex
                            align-items-center
                            justify-content-center
                            text-muted
                            mb-3
                          "
                        >
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            v-model="user.terms"
                            id="termsCheckbox"
                            name="termsCheckbox"
                            :class="{
                              'is-invalid': submitted && $v.user.terms.$error,
                            }"
                          />
                          <label
                            class="custom-control-label"
                            for="termsCheckbox"
                          >
                            <small>
                              Li e concordo com os
                              <a class="link-underline" href="#"
                                >Termos e Condições</a
                              >
                            </small>
                          </label>
                          <div
                            v-if="submitted && $v.user.terms.$error"
                            class="invalid-feedback text-left"
                          >
                            <span v-if="!$v.user.terms.required"
                              >Campo obrigatório.</span
                            >
                          </div>
                        </div>
                        <div class="d-flex justify-content-center">
                          <vue-recaptcha
                            v-show="!reCaptcha"
                            sitekey="6Le-pdUZAAAAAJ3w6RDnJZlJ63u5T8qFphjxAKhT"
                            :loadRecaptchaScript="true"
                            @verify="onVerify"
                            @expired="onExpired"
                          ></vue-recaptcha>
                        </div>
                        <button
                          v-show="reCaptcha"
                          v-if="!loadingBtn"
                          type="submit"
                          class="btn btn-primary btn-block"
                          :disabled="disableButton"
                        >
                          Enviar
                        </button>
                        <button
                          class="btn btn-primary btn-block"
                          type="button"
                          v-if="loadingBtn"
                          disabled
                        >
                          <span
                            class="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Loading...
                        </button>
                        <!--<div class="mt-3 text-center">
                          <span>Já tenho conta. </span>
                          <router-link to="/login">Entrar no App</router-link>
                        </div>-->
                      </b-col>
                    </b-row>

                    <!--<recaptcha
            v-show="!reCaptcha"
            class="mb-3"
            @error="onError"
            @success="onSuccess"
            @expired="onExpired"
          />-->
                  </form>
                </div>
              </div>
              <div class="d-flex justify-content-center mt-3">
                <div v-for="n in 3" :key="n">
                  <div
                    class="dot mx-3"
                    :class="{ dotBackground: n === step }"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { mask } from "vue-the-mask";
import { required, email, minLength, sameAs } from "vuelidate/lib/validators";
import VueRecaptcha from "vue-recaptcha";

export default {
  name: "register",
  data() {
    return {
      user: {
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        pass: "",
        pass2: "",
        profileType: "",
        averageCredit: "",
        wayOfPerformance: "",
        timeToMarket: "",
        actingRegion: "",
      },
      submitted: false,
      reCaptcha: false,
      step: 1,
      intiateFadeUp: false,
      agenciaDialog: false,
    };
  },
  methods: {
    ...mapActions(["createUser", "dismissed"]),
    reg(e) {
      e.preventDefault();
    },
    selectProfile(val) {
      this.intiateFadeUp = true;
      this.user.profileType = val;
      setTimeout(() => {
        if (this.user.profileType === "Agência") {
          this.step = 3;
          this.agenciaDialog = true;
        } else {
          this.step = 2;
        }
        this.intiateFadeUp = false;
      }, 1000);
    },
    movetoStepThree() {
      if (
        this.$v.user.averageCredit.$invalid ||
        this.$v.user.wayOfPerformance.$invalid ||
        this.$v.user.timeToMarket.$invalid ||
        this.$v.user.actingRegion.$invalid
      ) {
        return;
      }
      this.intiateFadeUp = true;
      setTimeout(() => {
        this.step = 3;
        this.intiateFadeUp = false;
      }, 1000);
    },
    handleSubmit(user) {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();
      user.fullName = `${user.firstName} ${user.lastName}`
      this.createUser(user);

      //alert("SUCCESS!! :-)\n\n" + JSON.stringify(user));
    },
    onError(error) {
      console.log("Error happened:", error);
    },
    onVerify(token) {
      console.log("Succeeded:", token);
      // here you submit the form
      // this.$refs.form.submit()
      this.reCaptcha = true;
    },
    onExpired() {
      console.log("Expired");
    },
  },
  computed: {
    ...mapState([
      "error",
      "errorMessage",
      "dismissCountDown",
      "loadingBtn",
      "profileUser",
      "dismissCountDown",
    ]),
    disableButton() {
      console.log(this.$v.user, "this.$v.userthis.$v.user");
      if (
        this.$v.user.firstName.$invalid ||
        this.$v.user.lastName.$invalid ||
        this.$v.user.phoneNumber.$invalid ||
        this.$v.user.email.$invalid ||
        this.$v.user.pass.$invalid ||
        this.$v.user.pass2.$invalid
      ) {
        return true;
      } else {
        false;
      }
      // return this.user.pass === this.user.pass2 && this.user.pass != "";
    },
  },
  directives: {
    mask,
  },
  components: { VueRecaptcha },
  validations: {
    user: {
      firstName: { required },
      lastName: { required },
      phoneNumber: { required },
      profileType: { required },
      email: { required, email },
      //note: { required },
      pass: { required, minLength: minLength(6) },
      pass2: { required, sameAsPassword: sameAs("pass") },
      terms: { required },
      averageCredit: { required },
      wayOfPerformance: { required },
      timeToMarket: { required },
      actingRegion: { required },
    },
  },
};
</script>

<style scoped>
.form-signin {
  width: 100%;
  /* max-width: 330px;
  padding: 15px; */
  margin: 0 auto;
}
.text-own {
  color: #0f394f;
  font-weight: 700;
}
.device-browser {
  /*position: relative;*/
  z-index: 1;
  display: block;
  max-width: 100%;
  width: 50rem;
  height: auto;
  margin-left: auto;
  margin-right: auto;
}
.device-browser-header {
  position: relative;
  display: flex;
  max-width: 50rem;
  background: #fff;
  border-bottom: 0.0625rem solid #f1f3f8;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
  padding: 0.5rem 6.5rem;
}
.device-browser-header-btn-list {
  display: flex;
  grid-gap: 0.25rem;
  position: absolute;
  top: calc(50% - 0.25rem);
  left: 1rem;
}
.device-browser-header-btn-list-btn {
  width: 0.5rem;
  height: 0.5rem;
  background-color: #e7eaf3;
  border-radius: 50%;
}
.device-browser-header-browser-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  color: #677788;
  background-color: #e7eaf3;
  font-size: 0.5rem;
  border-radius: 0.125rem;
}
.device-browser-frame {
  background: #fff;
  box-shadow: 0 2.75rem 5.5rem -3.5rem rgb(189 197 209 / 50%),
    0 2rem 4rem -2rem rgb(33 50 91 / 30%);
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.device-browser-img {
  max-width: 100%;
  height: auto;
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
img,
svg {
  vertical-align: middle;
}
.card {
  border-width: 0;
  box-shadow: 0rem 0.375rem 1.5rem 0rem rgb(140 152 164 / 13%);
}
.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 0.0625rem solid rgba(33, 50, 91, 0.1);
  border-radius: 0.5rem;
}
.zi-1 {
  z-index: 1 !important;
}
.mb-n5 {
  margin-bottom: -2rem !important;
}
.me-n5 {
  margin-right: -2rem !important;
}
.end-0 {
  right: 0 !important;
}
.top-80 {
  top: 80px !important;
}
.social-box .box {
  background: #fff;
  border-radius: 10px;
  padding: 20px 10px;
  margin: 20px 0px;
  cursor: pointer;
  transition: all 0.5s ease-out;
  border: 1px solid #b1cdf1;
  min-height: 132px;
  /*-webkit-box-align: center !important;
  align-items: center !important;
  -webkit-box-pack: center !important;
  justify-content: center !important;
  display: flex !important;*/
}

.social-box .box:hover {
  box-shadow: 0 0 6px #4183d7;
}

.social-box .box .box-text {
  margin: 20px 0px;
  font-size: 15px;
  line-height: 30px;
}

.social-box .box .box-btn a {
  text-decoration: none;
  color: #4183d7;
  font-size: 16px;
}

.bi {
  color: #4183d7;
}
.dot {
  width: 12px;
  height: 12px;
  border: 2px solid #4183d7;
  border-radius: 8px;
}

.dotBackground {
  background-color: #4183d7;
  transition: all 1s ease-out;
}
.fadeup {
  opacity: 0;
  transition: all 1s ease-out;
}

.f-14 {
  font-size: 14px;
}
.asd {
  background-image: url("../assets/img/tech.jpg");
  background-repeat: no-repeat;
  background-position: right;
  background-size: cover;
  opacity: 0.8;
}
.rightCol {
  margin-top: 100px;
}
</style>
